import { useLayoutEffect } from "react";

import { FullscreenLoading } from "../../components/FullscreenLoading";
import { redirect } from "../../utils";
import { getLogoutUrl } from "../../utils/authentication";

export const Logout = () => {
  useLayoutEffect(() => {
    redirect(getLogoutUrl(localStorage.getItem("ciam_id_token")));
  }, []);

  return <FullscreenLoading isVisible />;
};
